import styled from "styled-components";

export const StyledTableAprovacoes = styled.section`
width: 100%;
overflow: hidden;


.hover {
    &:hover {
        cursor: pointer;
    }
}

.default-button-red {
    max-width: 280px;
    min-width: 120px;
    padding: 0.5rem 1rem;
    cursor: pointer;
    font-weight: 600;
    border: solid 1px #EE4B21;
    border-radius: 0.25rem;
    background-color: #EE4B21;
    color: #FFF;
    font-size: 0.8rem;
    &:hover {
        background-color: #c83e1b;
        border: solid 1px #c83e1b;
    }
    &:disabled {
        cursor: not-allowed;
    }
}

.default-button {
    min-width: 120px;
    padding: 0.5rem 1rem;
    cursor: pointer;
    font-weight: 600;
    border: solid 1px #EE4B21;
    border-radius: 0.25rem;
    background-color: white;
    color: #EE4B21;
    font-size: 0.8rem;
}

.page-title {
    font-size: 24px;
    font-weight: bold;
    margin: -20px 0 13px 0;
}

.card-menu-hide {
    background: black;
    color: #fff;
    margin: 1rem;
    font-size: 11px;
    display: none;
    width: 50%;
    padding: 5px;
    border-radius: 7px;
}

.timeline-menu-show {
    position: absolute;
    box-shadow: 0px 0px 24px rgba(0, 0, 0, 0.05);
    border: 1px solid #bebebe;
    border-radius: 11px;
    z-index: 1;
}

.card {
    background-color: #fff;
    border-radius: .25rem;
    min-width: 90%;
    margin-top: 1rem;
    margin: 0;

    & .border-wrapper {
        border: solid 1px #ccc;
        border-radius: .25rem;
        padding: 1rem;
    }
}

.timesheet {



@media only screen and (min-width: 1350px) {
    .table-scroll {
        overflow-y: scroll;
        overflow-x: hidden !important;
    }

        .table-container {
            width: 100%;
            overflow-y: auto;
            overflow-x: hidden;
            height: calc(100vh - 370px);


            table {
                border-collapse: collapse;
                width: auto;
                table-layout: auto;
        }
            th,
            td {
            }

            th {
                background-color: #fff;
                position: sticky;
                top: 0;
            }
          }

}



    .table-scroll {
        overflow-x: scroll;
        overflow-y: hidden;
        width:100%;
        height:100%;
    }

    .table.table-bordered > thead > tr > th,
    table.table-bordered > tbody > tr > td {
        white-space: nowrap;
        border-top-style: solid;
        border-left-style: solid;
        border-right-style: solid;
    }

    .table-container {
        overflow-x: auto;
    }
    .table-container table {
        margin: 0;
    }

    .legend-value {
        color: green;
        font-weight: 1000;
    }

    .legend {
        color: green;
    }

    .table.table-bordered > thead > tr {
        box-shadow: inset 0 1px 0 #E8E8E8, inset 0 -1px 0 #E8E8E8;
    }


    .width-30 {
        width: 30px;
    }

    .width-35 {
        width: 35px;
    }

    .width-40 {
        width: 40px;
    }

    .width-45 {
        width: 45px;
    }

    .width-50 {
        width: 50px;
    }

    .width-60 {
        width: 60px;
    }

    .width-70 {
        width: 70px;
    }

    .width-80 {
        width: 80px;
    }

    .width-96 {
        width: 96px;
    }

    .width-116 {
        width: 116px;
    }

    .width-150 {
        width: 148px;
    }

    .table.table-bordered > thead {
        background-color: #fff;
        position: -webkit-sticky;
        position: sticky;
        top: 0;
    }

    table.table-bordered > tfoot {
        background-color: #fff;
        position: -webkit-sticky;
        position: sticky;
        bottom: 0;
    }

    table.table-bordered > tfoot > tr > td {
        white-space: nowrap;
        border-top-style: solid;
        border-left-style: solid;
        border-right-style: solid;
        font-size: 12px;
        text-align: right;
        font-weight: 1000;
    }


}

.header-items {
        a {
            padding: 0 3px;
            color: #cac6c6;

            &:hover {
                color: #c83e1b;
            }

            i {
                font-size: 17px;
                padding: 0 2px;
            }

            .possui-comentarios {
                color: #EE4B21;
            }
        }
    }



.revisaoCard{
    background: #f1626240 !important;
}

.esclarecimentoCard{
    background: #f3e8f3 !important;
}

.notificacaoCard{
    background: #f7cc4d61 !important;
}

.probonoCard {
    background: #cdeeff;
}

.text-revisaoCard{
    color: #f1626240 !important;
}

.text-notificacaoCard{
    color: #f7cc4d61 !important;
}


.prazo-error {
    color: #dc3545;
}

.prazo-warning {
    color: #ffc107;
}

.prazo-success {
    color: #28a745;
}


.text-error {
    color: #dc3545 !important;
}

.text-primary {
    color: #0b5ed7 !important;;
}

.text-success {
    color: #28a745 !important;
}


}


.timesheet{
    margin-top: 0rem;
}


.collumResetBtn{
    width: 10ch !important;
}



.collumResetBtn {
    top: 111px;
    left: 20px;
    height: 38px;
    position: absolute;
    width: 5ch !important;
    padding: 0.10rem;
    cursor: pointer;
    font-weight: 600;
    border: solid 1px #EE4B21;
    border-radius: 0.25rem;
    background-color: #EE4B21;
    color: #EE4B21;

    &:hover {
       background-color: #c83e1b;
        border: solid 1px #c83e1b;
    }
    &:disabled {
        cursor: not-allowed;
    }
}

.collumAprovarBtn {
    top: 103px;
    left: 73px;
    position: absolute;
    width: auto !important;
    cursor: pointer;
    font-weight: 600;
    margin-left: 10px;
    height: 38px;
}

.table-container-aprovacoes {
    margin-top: 1rem;
}

.collumAprovarAllBtn {
    top: 111px;
    left: 251px;
    height: 38px;
    position: absolute;
    width: 5ch !important;
    padding: 0.10rem;
    cursor: pointer;
    font-weight: 600;
    border: solid 1px #EE4B21;
    border-radius: 0.25rem;
    background-color: #FFFFFF;
    color: #EE4B21;

    &:hover {
        background-color: #ffe8e0;
        border-color: #EE4B21;
    }
    &.ativo {
        background-color: #EE4B21;
        color: #FFFFFF;
        border-color: #EE4B21;
    }

    .ml-2, .mx-2 {
        margin-left: 0.0rem !important;
    }
}
`;
